<template>
  <Header />
  <div class="research sticky-research">
    <div class="research-wrap">
      <div class="search-box-research">
        <div class="search-content-research">
          <i class="fa-solid fa-location-dot" style="color: #1053c6;"></i>
          <select
            v-model="formResearch.area"
            name="parentCategory"
            class="select-location"
          >
            <option style="margin: 8px" value="">エリアを選ぶ</option>
            <option
              class="select-option"
              :value="item.id"
              v-for="(item, index) in listLocation"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="search-content search-content-calendar">
         <div class="search-content-calendar-input"  @click='handleShowPopUp'>
            <i class="fa-regular fa-calendar" style="color: #1053c6;"></i>
            <input
              v-model="formResearch.dateTime"
              id="select-calendar"
              placeholder="利用日時"
              autocomplete="off"
              inputmode="none"
              readonly
            >
         </div>
         <button class="search-content-calendar-btn-reset"
         :class="{ 'active' : formResearch.dateTime != '' }"
         @click="handleRemoveDate"
         >
          <i class="fa fa-times" style="color: #1053c6;"></i>
         </button>
        </div>
        <div class="search-content-research">
          <i class="fa-brands fa-font-awesome" style="color: #1053c6;"></i>
          <select
            v-model="formResearch.category"
            name="parentCategory"
            class="select-location"
          >
            <option value="">利用用途を選ぶ</option>
            <option
              :value="item.id"
              v-for="(item, index) in listCategory"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="search-content-research">
          <i class="fa-solid fa-users" style="color: #1053c6;"></i>
          <select
            v-model="formResearch.people"
            name="parentCategory"
            class="select-location"
          >
            <option value="">人数を選ぶ</option>
            <option
              :value="item.id"
              v-for="(item, index) in listPeople"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
        </div>

        <button tile color="#297fca" size="x-small" :class="{ 'active' : formResearch.dateTime != '' }" @click="handelToResearchMain">
          <i class="fa-solid fa-magnifying-glass" style="color: #fff;"></i>
          検索する
        </button>
      </div>
    </div>
    <h4 class="search-note">条件を全て入力しなくても検索は可能です。</h4>
  </div>

  <!-- <div class="sp_research">
    <div @click="isShowSearchModal = true" class="search_results_wrap_inner_box_open">
        <i class="fas fa-search"></i>
        <span v-if="location">{{ location }}</span>
        <span v-if="category">{{ category }}</span>
        <span v-if="peopleSearch">{{ peopleSearch }}</span>
    </div>
  </div>
  <v-dialog v-model="isShowSearchModal">
    <SearchModal @closeModal="isShowSearchModal = false" />
  </v-dialog> -->

  <v-dialog v-model="isShowModalCalendar" class="c-popup-calendar">
      <ModalSearchCalendar
        @handleCloseModal="handleCloseModal"
        @selectDate="handleSelectDate"
        @selectTimeStart="handleSelectTimeStart"
        @selectTimeEnd="handleSelectTimeEnd"
        @handleSelectFullDateTime="handleSelectFullDateTime"
        :dataPopup="dataPopup"
      />
  </v-dialog>

  <div class="list_space">
    <ListSpace
      :dataList="spaceRent"
      listHeader="検索結果一覧"
      class="listSpace"
    />
    <div v-if="!spaceRent?.length && storeCustomer.isLoading == false" class="no-data-search">
      <li>検索結果はありません</li>
      <li>エリアやカテゴリー、人数の条件を変えてみることで</li>
      <li>
        条件に合った貸し会議室・レンタルスペースが表示されるかもしれません。
      </li>
    </div>
  </div>
  <Footer />
  <ContactInfo />
</template>

<script>
import { ref, inject, watch, onMounted, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
import Header from "@/client/organisms/LayoutHome/Header/Header.vue";
import ListSpace from "@/client/views/ListSpaceOfArea/ListSpace/ListSpace.vue";
import Footer from "@/client/organisms/LayoutHome/Footer/Footer.vue";
import ContactInfo from "@/client/organisms/LayoutHome/ContactInfo/ContactInfo.vue";
import { useRouter, useRoute } from "vue-router";
import { RENTAL_SPACE_STATUS } from "@/client/const";
import {
  getListSpaceByLocationApi,
} from "@/client/api";
import useStoreCustomer from "@/client/store/Customer";
// import SearchModal from "@/client/views/SpaceResearch/Modal/SearchModal.vue";
// import SearchComponent from "@/client/components/SearchComponent/SearchComponent.vue";
import  ModalSearchCalendar from "@/client/components/SearchComponent/ModalSearchCalendar.vue";


export default {
  name: "spaceResearch",
  components: {
    Header,
    ListSpace,
    Footer,
    // SearchModal,
    ContactInfo,
    ModalSearchCalendar
  },
  async setup() {
    // const isShowSearchModal = ref(false);
    const storeCustomer = useStoreCustomer();
    storeCustomer.isLoading = true;
    const toast = inject("$toast");
    const { t } = useI18n();
    const route = useRoute();
    const spaceRent = ref([]);
    const detailLocation = ref();
    const listLocation = ref([]);
    const listCategory = ref([]);
    const router = useRouter();
    const isShowModalCalendar = ref(false);
    const dataPopup = ref({
      date:'',
      timeStart:'',
      timeEnd:'',
    })

    const handleShowPopUp = () => {
      isShowModalCalendar.value = true;
      const valueInputSelectCalendar = document.getElementById("select-calendar").value;
      if(valueInputSelectCalendar && valueInputSelectCalendar !== '利用日時'){
        const obj = valueInputSelectCalendar.split(" ");
        const time = obj[1].split('～');
        dataPopup.value.date = obj[0].replaceAll("/","-")
        dataPopup.value.timeEnd = time[1]
        dataPopup.value.timeStart = time[0]
      }
    };
    const handleCloseModal = () => {
      isShowModalCalendar.value = false;
    }
    const handleSelectDate = (data) => {
      formResearch.value.date = data;
    }
    const handleSelectTimeStart= (data) => {
      formResearch.value.timeStart = data;
    }
    const handleSelectTimeEnd= (data) => {
      formResearch.value.timeEnd = data;
    };
    const handleSelectFullDateTime = (data) => {
      formResearch.value.dateTime = data
    }

    const listPeople = [
      { name: "ブース(個室)", id: '1-5' },
      { name: "~20人", id: '6-20' },
      { name: "21~40人", id: '21-40' },
      { name: "41~60人", id: '41-60' },
      { name: "61~100人", id: '61-100' },
      { name: "101人~", id: '101-' },
    ];
    const listPeopleFormTo = [
      {id: '1-5', data: { from: 1, to: 5 }},
      {id: '6-20', data: { from: 6, to: 20 }},
      {id: '21-40', data: { from: 21, to: 40 }},
      {id: '41-60', data: { from: 41, to: 60 }},
      {id: '61-100', data: { from: 61, to: 100 }},
      {id: '101-', data: { case_person: 101 }}
    ];
    const formResearch = ref({
      area: "",
      date: "",
      timeStart: "",
      timeEnd: "",
      category: "",
      people: "",
      dateTime: "",
    });

    const dataRouter = ref({
      area: route.query.area ? route.query.area : '',
      date: route.query.date ? route.query.date : '',
      timeStart: route.query.timeStart ? route.query.timeStart : '',
      timeEnd: route.query.timeEnd ? route.query.timeEnd : '',
      category: route.query.category ? route.query.category : '',
      people: route.query.people? route.query.people : '',
      dateTime: route.query.date ? route.query.date + ' ' + route.query.timeStart + '～' + route.query.timeEnd : '',
    });

    const peopleSearch = ref(dataRouter.value.people.replace('-', '〜'));
    watch(
      dataRouter,
      (val) => {
        formResearch.value.area = val.area;
        formResearch.value.category = val.category;
        formResearch.value.dateTime = val.dateTime;

        listPeopleFormTo.forEach((element) => {
          if (element.id == val.people) {
            formResearch.value.people = val.people;
          }
          if (element.data == val.people) {
            formResearch.value.people = element.id;
          }
        });
      },
      {
        immediate: true,
        deep: true,
      }
    );
    const filterNameFromRouter = () => {};
    const contentImg = route.query.nameLocation;
    const subContent = t("locations.sub_content");
    const meeting = t("list_space.meeting");

    const location = ref();
    const category = ref();
    watch(() => [storeCustomer.getListLocation, storeCustomer.getListCategory], function() {
      const resLocation = storeCustomer.getListLocation;
      const resCategory = storeCustomer.getListCategory;
      if (Array.isArray(resCategory) && Array.isArray(resLocation)) {
        if (listCategory.value.length == 0 && listLocation.value.length == 0) {
          listLocation.value = resLocation.map((el) => {
            return { name: el.name, id: el.id, slug: el.slug };
          });
          listLocation.value.forEach((element) => {
            if (element.id == formResearch.value.area) {
              location.value = element.name;
            }
          });
          listCategory.value = resCategory.map((el) => {
            return { name: el.name, id: el.id };
          });
          listCategory.value.forEach((element) => {
            if (element.id == formResearch.value.category) {
              category.value = element.name;
            }
          });
          getListSpaceByLocation();
        }
      }
    });

    watch( ()=> {
      window.scrollTo({ top: 0, behavior: "smooth" });
    })

    const getListSpaceByLocation = async () => {
      let peopleData = [];
      if (dataRouter.value.people != "") {
        let people = dataRouter.value.people.split("-").filter(Boolean);
        if (people.length == 1) {
          peopleData["case_person"] = people[0];
        } else if (people.length == 2) {
          peopleData["from"] = people[0];
          peopleData["to"] = people[1];
        }
      }
      try {
        let dataSearch = {
          area_id: dataRouter.value.area,
          selectedDate: dataRouter.value.date,
          timeStart: dataRouter.value.timeStart,
          timeEnd: dataRouter.value.timeEnd,
          ts_category_spaces_id: dataRouter.value.category,
          people_count: {},
          status: RENTAL_SPACE_STATUS.published,
          no_paginate: true,
          fe: 'vn'
        };
        if ("from" in peopleData) {
          dataSearch.people_count.from = peopleData["from"];
        }
        if ("to" in peopleData) {
          dataSearch.people_count.to = peopleData["to"];
        }
        if ("case_person" in peopleData) {
          dataSearch.people_count.case_person = peopleData["case_person"];
        }
        if (peopleData['from'] != undefined && peopleData['to'] != undefined) {
          let people = dataRouter.value.people;
          const result = listPeopleFormTo.filter((item) => {
            return people == item.id;
          });
          if (result.length > 0) {
            const res = await getListSpaceByLocationApi(dataSearch);
            spaceRent.value = res.data.data.map((item) => ({
              ...item,
              image_url:
                item.rental_space_image.length != 0
                  ? `${item.rental_space_image[0].url_image}`
                  : "",
            }));
          }
        } else {
          const res = await getListSpaceByLocationApi(dataSearch);
          spaceRent.value = res.data.data.map((item) => ({
            ...item,
            image_url:
              item.rental_space_image.length != 0
                ? `${item.rental_space_image[0].url_image}`
                : "",
          }));
        }
      } catch (errors) {
        toast.error("has error");
      } finally {
        storeCustomer.isLoading = false;
      }
    };

    const handelToResearchMain = async () => {
      storeCustomer.isLoading = true;
      try {
        if(formResearch.value?.group_area) {
          formResearch.value.grouparea = listLocation.value.find(it => it.id == formResearch.value.group_area)?.slug
          dataRouter.value.grouparea = formResearch.value?.grouparea;
        }
        dataRouter.value.group_area = formResearch.value?.group_area;
        dataRouter.value.category = formResearch.value?.category;
        dataRouter.value.date = formResearch.value?.date ? formResearch.value?.date : dataRouter.value.date;
        dataRouter.value.timeEnd = formResearch.value?.timeEnd ? formResearch.value?.timeEnd : dataRouter.value.timeEnd;
        dataRouter.value.timeStart = formResearch.value?.timeStart ? formResearch.value?.timeStart : dataRouter.value.timeStart;
        dataRouter.value.people = '';
        dataRouter.value.dateTime = formResearch.value?.dateTime;
        listPeopleFormTo.forEach((element) => {
          if (element.id == formResearch.value?.people) {
            dataRouter.value.people = element.id;
          }
        });
        router.push({
          path: route.path,
            query: {
              grouparea: dataRouter.value.grouparea,
              date: dataRouter.value.date,
              timeStart: dataRouter.value.timeStart,
              timeEnd: dataRouter.value.timeEnd,
              category: dataRouter.value.category,
              people: dataRouter.value.people,
              group_area: dataRouter.value.dataRouter

            }
        });
        await getListSpaceByLocation();
      } catch (error) {
        toast.error('has error');
      } finally {
        storeCustomer.isLoading = false;
      }
    };

    const handleRemoveDate = () => {
      const selectCalendar = document.querySelector("#select-calendar");
      const btnRevemoValueDate = document.querySelector(".search-content-calendar-btn-reset");
      btnRevemoValueDate.classList.remove('active')
      selectCalendar.value = '';
      formResearch.value.date = '';
      dataRouter.value.date = '';
      formResearch.value.timeEnd = '';
      formResearch.value.timeStart = '';
      dataRouter.value.timeStart = '';
      dataRouter.value.timeEnd = '';
      formResearch.value.dateTime = '';
      dataRouter.value.dateTime = '';
      router.push({
        query: formResearch.value,
        replace: true,
      })
    };

    const handleSetTop = () => {
      const elHeader = document.querySelector(".header");
      const elStickyResearch = document.querySelector(".sticky-research");

      if (elHeader && elStickyResearch) {
        const heightElHeader = elHeader.offsetHeight;
        elStickyResearch.style.top = heightElHeader + 'px';
      }
    }

    onMounted(() => {
      handleSetTop();
      window.onresize = () => {
        handleSetTop();
      }
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleSetTop);
    });

    return {
      contentImg,
      subContent,
      spaceRent,
      meeting,
      detailLocation,
      formResearch,
      listLocation,
      listCategory,
      listPeople,
      listPeopleFormTo,
      dataRouter,
      handelToResearchMain,
      filterNameFromRouter,
      location,
      category,
      peopleSearch,
      storeCustomer,
      handleShowPopUp,
      handleCloseModal,
      handleSelectDate,
      handleSelectTimeEnd,
      handleSelectTimeStart,
      handleSelectFullDateTime,
      // dataFullDateTime,
      isShowModalCalendar,
      dataPopup,
      handleRemoveDate
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/client/views/SpaceResearch/SpaceResearch.scss";

.list_space {
  padding-bottom: 40px;
  max-width: 1200px;
  margin: auto;
}
@media screen and (min-width: 600px ) {
  .research.sticky-research {
    position: sticky;
    z-index: 10;
    background-color: #FFF;
  }
}
</style>
